import { render, staticRenderFns } from "./participantLeft.vue?vue&type=template&id=f6c20720&"
import script from "./participantLeft.vue?vue&type=script&lang=js&"
export * from "./participantLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports